<template>
  <v-dialog
    v-model="enableDialog"
    persistent
    width="600"
  >
    <validation-observer
      ref="requesterFormValidator"
    >
      <v-form>
        <v-card>
          <v-card-title>申請者の追加</v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  class="requiredMark"
                  rules="required|length:7|alpha_num_only"
                  name="申請者の加入者番号"
                >
                  <v-text-field
                    v-model="forms.subscriber_number"
                    :error-messages="errors"
                    label="申請者の加入者番号"
                    hide-details="auto"
                    persistent-placeholder
                  >
                    <template v-slot:label>
                      <span>申請者の加入者番号</span>
                      <span class="ml-1">
                        ({{ forms.subscriber_number?.length || 0 }} / 7)
                      </span>
                    </template>
                    <template v-slot:counter></template>
                    <template v-slot:append>
                      <v-btn
                        outlined
                        small
                        @click="searchRequestTenantButtonClickEvent"
                      >
                        検索
                      </v-btn>
                    </template>
                  </v-text-field>
                </validation-provider>
              </v-col>
              <v-col>
                <validation-provider
                  v-slot="{ errors }"
                  tenant_name="申請者の加入者名称"
                >
                  <v-text-field
                    v-model="forms.tenant_name"
                    :error-messages="errors"
                    label="申請者の加入者名称"
                    hide-details="auto"
                    persistent-placeholder
                    readonly
                  />
                </validation-provider>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn
              @click="closeButtonClickEvent"
            >
              閉じる
            </v-btn>
            <v-btn
              color="primary"
              @click="registerButtonClickEvent"
            >
              追加
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </validation-observer>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'EmissionRequesterDialog',
  components: {},
  mixins: [],
  props: {
    enableDialog: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      forms: {
        subscriber_number: null,
        tenant_name: null,
        _destroy: false,
      }
    }
  },
  computed: {},
  watch: {
    enableDialog (newValue) {
      this.$nextTick(() => this.$refs.requesterFormValidator.reset())
      Object.assign(this.$data.forms, this.$options.data().forms);

    },
  },
  created() {
  },
  methods: {
    ...mapActions('AdminMasterTenant', {
      searchRequestTenant: 'show'
    }),
    searchRequestTenantButtonClickEvent () {
      this.searchRequestTenant({subscriber_number: this.forms.subscriber_number}).then((content) => {
        if (content.exists) {
          this.forms.tenant_name = content.name
        }
      })
    },
    closeButtonClickEvent () {
      this.$emit('closeEvent')
    },
    registerButtonClickEvent () {
      let $self = this
      this.$refs.requesterFormValidator.validate().then((result) => {
        if(result){
          this.searchRequestTenant({subscriber_number: this.forms.subscriber_number}).then((content) => {
            if (content.exists) {
              $self.sendRegistrationInformation()
            }
          })
        }
      })
    },
    sendRegistrationInformation () {
      let params = {
        subscriber_number: this.forms.subscriber_number,
        tenant_name: this.forms.tenant_name,
        _destroy: false,
      }
      this.$emit('registerEvent', params)
    },
  }
}
</script>

<style scoped lang="scss">

</style>
